/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, EventEmitter, OnInit, ViewChild,} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {NgSelectComponent} from '@ng-select/ng-select';
import {BaseComponent, Catalog, FileService, Product} from 'compob2b-libs';
import {map, takeUntil} from 'rxjs/operators';
import {translations} from '../../../../../environments/translations.ru';
import {FormConfigService} from '../../../../admin-shared/services/form-config.service';
import {CatalogService} from '../../catalog/catalog.service';

@Component({
  selector: 'app-catalogs-links-modal',
  templateUrl: './catalogs-links-modal.component.html',
  styleUrls: ['./catalogs-links-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogsLinksModalComponent extends BaseComponent implements OnInit {

  public productModel: Product;
  public insertAdditionalCatalogEvent: EventEmitter<Catalog>;
  public removeAdditionalCatalogEvent: EventEmitter<Catalog>;
  public checkedCatalogs = new Set<number>();
  public selectedCatalogs = [];
  public catalogs: Catalog[];

  buffer: any[] = [];
  loading = false;
  bufferSize = 50;
  numberOfItemsFromEndBeforeFetchingMore = 10;

  constructor(
    protected readonly formsConfig: FormConfigService,
    protected readonly route: ActivatedRoute,
    private readonly catalogService: CatalogService,
    protected readonly fileService: FileService,
  ) {
    super();
  }

  @ViewChild('selectElement') public selectElement: NgSelectComponent;

  ngOnInit(): void {
    this.loading = true;
    this.catalogService
      .getLazyCatalogTree()
      .pipe(
        map(response => response.filter(element => (element.header !== translations.root))
        ))
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(catalogTree => {
        catalogTree = catalogTree.map(item => {
          item.disabled = !item.lastLevel;
          return item;
        });
        this.catalogs = catalogTree;
        this.loading = false;
        this.cdr.detectChanges();
        this.productModel.catalogs.forEach(catalog => {
            this.checkedCatalogs.add(catalog.id);
            this.selectedCatalogs.push(catalog.id);
          }
        );
        this.selectedCatalogs = [...this.selectedCatalogs];
        this.selectElement.open();
        this.cdr.detectChanges();
      });

  }

  toggle(isRelation: boolean, catalog: Catalog) {

    if (catalog.lastLevel === false) {
      return false;
    }
    if (isRelation) {
      if (!this.checkedCatalogs.has(catalog.id)) {
        this.checkedCatalogs.add(catalog.id);
        this.insertAdditionalCatalogEvent.emit(catalog);
      }
    } else {
      if (this.checkedCatalogs.has(catalog.id)) {
        this.checkedCatalogs.delete(catalog.id);
        this.removeAdditionalCatalogEvent.emit(catalog);
      }
    }
  }

  public onScrollToEnd() {
    this.fetchMore();
  }

  public onScroll({end}) {
    if (this.loading || this.catalogs.length <= this.buffer.length) {
      return;
    }

    if (end + this.numberOfItemsFromEndBeforeFetchingMore >= this.buffer.length) {
      this.fetchMore();
    }
  }

  private fetchMore() {
    const len = this.buffer.length;
    const more = this.catalogs.slice(len, this.bufferSize + len);
    this.loading = false;
    this.buffer = this.buffer.concat(more);
  }

}

